import { createContext } from "react";

interface TranslationContextProps {
    getTranslatedString: (translationToken: string) => string;
    getTranslatedErrorMessage: (translationToken: string) => string;
}

export const TranslationContext = createContext<TranslationContextProps | undefined>(undefined);
